import React from "react";
import { Modal, Button } from "react-bootstrap";
import Icon from "@mdi/react";
import {
  mdiCreditCardSettingsOutline,
  mdiFileDocumentOutline,
  mdiBankOutline,
} from "@mdi/js";
import "./paymentConnection.css";

const STEPS = [
  {
    icon: mdiCreditCardSettingsOutline,
    title: "Set Up Your Payment Account",
    description:
      "A one-time setup through Stripe to start accepting card payments from clients.",
  },
  {
    icon: mdiFileDocumentOutline,
    title: "Send a Payment Request",
    description: "Create a payment request from any Job and share it by text or email.",
  },
  {
    icon: mdiBankOutline,
    title: "Get Paid to Your Bank",
    description:
      "Clients pay by card online. Stripe collects the payment and sends the funds to your bank account.",
  },
];

const HowPaymentsWorkModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} centered className="pc-modal">
    <Modal.Header closeButton>
      <Modal.Title>How Payments Work</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="d-flex flex-column gap-4">
        {STEPS.map((step) => (
          <div className="d-flex align-items-start gap-3" key={step.title}>
            <Icon
              path={step.icon}
              size={1.33}
              className="text-primary flex-shrink-0"
            />
            <div>
              <p className="fw-semibold mb-1">{step.title}</p>
              <p className="mb-0">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={onHide}>
        Got it
      </Button>
    </Modal.Footer>
  </Modal>
);

export default HowPaymentsWorkModal;
